import type { CombinedError } from 'urql';

const INVITE_UNAVAILABLE_MESSAGE = 'invite unavailable';

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

function hasInviteUnavailableMessage(error: CombinedError) {
  return error.graphQLErrors.some((graphQLError) => {
    if (graphQLError.message === INVITE_UNAVAILABLE_MESSAGE) {
      return true;
    }

    const internal = graphQLError.extensions?.internal;

    if (!isRecord(internal) || !isRecord(internal.error)) {
      return false;
    }

    return internal.error.message === INVITE_UNAVAILABLE_MESSAGE;
  });
}

export default function isJoinTerminalFailure(
  entityId: string | null | undefined,
  error: CombinedError | undefined,
) {
  if (entityId) {
    return false;
  }

  return !error || hasInviteUnavailableMessage(error);
}
